import { SxProps, Theme } from "@mui/material";

export const DASHBOARD_CARD_HEADER_SX: SxProps<Theme> = {
    backgroundColor: '#15478d',
    color: '#ffffff',
};

export const DASHBOARD_CARD_SX: SxProps<Theme> = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '25px !important',
    boxShadow: (theme) => theme.shadows[2],
    transition: (theme) =>
        theme.transitions.create(['transform', 'box-shadow'], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
        }),
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: (theme) => theme.shadows[6],
    },
};